import { SVGProps } from 'react'

export const FileUpload = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20" {...props}>
    <path
      fill="currentColor"
      d="M7.5 13.75h5v-5h3.333L10 2.917 4.167 8.75H7.5v5zm-3.333 1.666h11.666v1.667H4.166v-1.666z"
    ></path>
  </svg>
)
